// Conversation ID store for managing Dify conversation mappings
// This mimics the Zustand store from your Next.js app but using a simple singleton pattern

interface ConversationStore {
  conversationId: string | null;
  conversationMapping: Record<string, string>; // remoteId -> conversationId
}

let store: ConversationStore = {
  conversationId: null,
  conversationMapping: {},
};

export const useConversationStore = {
  getState: () => store,
  
  setConversationId: (id: string) => {
    store = { ...store, conversationId: id };
  },
  
  clearConversationId: () => {
    store = { ...store, conversationId: null };
  },
  
  setConversationMapping: (remoteId: string, conversationId: string) => {
    store = {
      ...store,
      conversationMapping: { ...store.conversationMapping, [remoteId]: conversationId },
    };
  },
  
  getConversationId: (remoteId: string): string | null => {
    return store.conversationMapping[remoteId] || null;
  },
};
